module.exports = __webpack_public_path__ + "static/assets/277cf108a773b6a4aa2c3b73c33d8227.png";